import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const fmt = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return d > 0 ? `${d}d ${h}h ${pad(m)}m` : `${h}h ${pad(m)}m ${pad(sec)}s`;
};
const ago = (iso, now) => {
  const s = Math.max(0, Math.round((now - new Date(iso)) / 1000));
  return s < 60 ? `${s}s ago` : s < 3600 ? `${Math.floor(s / 60)}m ago` : `${Math.floor(s / 3600)}h ago`;
};
const NOTE = { "pre-market": "Pre-market trading now", "after-hours": "After-hours until 8:00 PM ET" };

export default function MarketCountdown() {
  const [clock, setClock] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const load = () => axios.get(`${BACKEND}/api/market/clock`).then(r => setClock(r.data)).catch(() => {});
    load();
    const poll = setInterval(load, 60000);
    const tick = setInterval(() => setNow(Date.now()), 1000);
    return () => { clearInterval(poll); clearInterval(tick); };
  }, []);

  useEffect(() => {
    if (!clock) return;
    const target = new Date(clock.is_open ? clock.next_close : clock.next_open);
    if (now >= target) axios.get(`${BACKEND}/api/market/clock`).then(r => setClock(r.data)).catch(() => {});
  }, [now, clock]);

  if (!clock) return null;
  const open = clock.is_open;
  const remaining = new Date(open ? clock.next_close : clock.next_open) - now;
  const urgent = remaining < 15 * 60 * 1000;
  const dot = open ? (urgent ? "bg-amber-400" : "bg-bt-positive") : (urgent ? "bg-amber-400" : "bg-bt-negative");
  const color = urgent ? "text-amber-400" : open ? "text-bt-positive" : "text-bt-text-secondary";
  const note = clock.holiday ? `Closed for ${clock.holiday}` : clock.early_close ? "Early close today · 1:00 PM ET" : NOTE[clock.phase];
  const title = `US market ${open ? "closes" : "opens"} ${new Date(open ? clock.next_close : clock.next_open).toLocaleString()}`
    + (clock.next_open_holiday_skipped?.length ? ` (skipping ${clock.next_open_holiday_skipped.join(", ")})` : "");

  return (
    <div className="shrink-0 flex items-center gap-2 px-3 py-1.5 bg-bt-surface border border-bt-border-subtle font-mono text-xs" title={title} data-testid="market-countdown">
      <span className={`w-2 h-2 rounded-full ${dot} ${open ? "animate-pulse" : ""}`} />
      <span className="text-bt-text-tertiary">{open ? "Closes in" : "Opens in"}</span>
      <span className={color} data-testid="market-countdown-time">{fmt(remaining)}</span>
      <span className="hidden md:inline text-[10px] text-bt-text-tertiary" data-testid="market-countdown-note">
        {note ? `· ${note} ` : ""}{clock.prices_updated ? `· Prices ${ago(clock.prices_updated, now)}` : ""}
      </span>
    </div>
  );
}
